(function () {
    'use strict';

    angular.module("imApp").factory("selectProjectService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1002,
                    parameters: parms || {}
                });
            },
            listProjects: function (parms) {
                return $ihttp.post({
                    method: 902,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
